/* eslint-disable */
// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies,long_type_string,optimize_speed,eslint_disable,ts_nocheck
// @generated from protobuf file "manager/core/proto/merge-tags.proto" (package "manager.core.mergetags", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MergeTagService } from "./merge-tags";
import type { HydrateMergeTagsResponse } from "./merge-tags";
import type { HydrateMergeTagsRequest } from "./merge-tags";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetUnitMergeTagsResponse } from "./merge-tags";
import type { GetUnitMergeTagsRequest } from "./merge-tags";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * Merge tags: placeholders such as `{CUSTOMER_NAME}` in task descriptions and
 * project overviews, filled with values of the project or task. Used by the
 * Legacy task and project editors and the customer portal. A tag is either
 * built in (customer, project manager, provider, task assignee) or a custom
 * field that is not internal only.
 *
 * @generated from protobuf service manager.core.mergetags.MergeTagService
 */
export interface IMergeTagServiceClient {
    /**
     * Lists the merge tags for a context, for the tag picker of an editor.
     * Without `unit_id` it returns every tag with no values. With `unit_id` it
     * returns values for that project or task, and its custom field tags are
     * only the project custom fields that have a value. To fill a text, use
     * HydrateMergeTags.
     *
     * @generated from protobuf rpc: GetUnitMergeTags(manager.core.mergetags.GetUnitMergeTagsRequest) returns (manager.core.mergetags.GetUnitMergeTagsResponse);
     */
    getUnitMergeTags(input: GetUnitMergeTagsRequest, options?: RpcOptions): UnaryCall<GetUnitMergeTagsRequest, GetUnitMergeTagsResponse>;
    /**
     * Replaces the merge tags in a text with the values of a project or task.
     * The caller needs read access to that project or task. Only project custom
     * field values are filled, not task custom field values. To list the tags,
     * use GetUnitMergeTags.
     *
     * @generated from protobuf rpc: HydrateMergeTags(manager.core.mergetags.HydrateMergeTagsRequest) returns (manager.core.mergetags.HydrateMergeTagsResponse);
     */
    hydrateMergeTags(input: HydrateMergeTagsRequest, options?: RpcOptions): UnaryCall<HydrateMergeTagsRequest, HydrateMergeTagsResponse>;
}
/**
 * Merge tags: placeholders such as `{CUSTOMER_NAME}` in task descriptions and
 * project overviews, filled with values of the project or task. Used by the
 * Legacy task and project editors and the customer portal. A tag is either
 * built in (customer, project manager, provider, task assignee) or a custom
 * field that is not internal only.
 *
 * @generated from protobuf service manager.core.mergetags.MergeTagService
 */
export class MergeTagServiceClient implements IMergeTagServiceClient, ServiceInfo {
    typeName = MergeTagService.typeName;
    methods = MergeTagService.methods;
    options = MergeTagService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Lists the merge tags for a context, for the tag picker of an editor.
     * Without `unit_id` it returns every tag with no values. With `unit_id` it
     * returns values for that project or task, and its custom field tags are
     * only the project custom fields that have a value. To fill a text, use
     * HydrateMergeTags.
     *
     * @generated from protobuf rpc: GetUnitMergeTags(manager.core.mergetags.GetUnitMergeTagsRequest) returns (manager.core.mergetags.GetUnitMergeTagsResponse);
     */
    getUnitMergeTags(input: GetUnitMergeTagsRequest, options?: RpcOptions): UnaryCall<GetUnitMergeTagsRequest, GetUnitMergeTagsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetUnitMergeTagsRequest, GetUnitMergeTagsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Replaces the merge tags in a text with the values of a project or task.
     * The caller needs read access to that project or task. Only project custom
     * field values are filled, not task custom field values. To list the tags,
     * use GetUnitMergeTags.
     *
     * @generated from protobuf rpc: HydrateMergeTags(manager.core.mergetags.HydrateMergeTagsRequest) returns (manager.core.mergetags.HydrateMergeTagsResponse);
     */
    hydrateMergeTags(input: HydrateMergeTagsRequest, options?: RpcOptions): UnaryCall<HydrateMergeTagsRequest, HydrateMergeTagsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<HydrateMergeTagsRequest, HydrateMergeTagsResponse>("unary", this._transport, method, opt, input);
    }
}
